import { render } from "./AttachmentsRow.vue?vue&type=template&id=7e0a3a5e"
import script from "./AttachmentsRow.vue?vue&type=script&lang=js"
export * from "./AttachmentsRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__